/*
 * Điều khiển trạng thái CTA kiểu Coterie: buộc chọn size trước khi bật "Thêm vào giỏ".
 *  - SP nhiều size, CHƯA chọn → khoá CTA + Mua ngay + sticky, nhãn "Chọn size".
 *  - Đã chọn size còn hàng → bật lại, nhãn "Thêm vào giỏ — Size X".
 *  - Đã chọn nhưng hết hàng → "Đã bán hết".
 *  - SP 1 biến thể (không có lưới size) → không can thiệp (giữ nhãn Liquid gốc).
 * Nguồn sự thật = radio size đang checked + class 'disabled' (hết hàng), KHÔNG phụ thuộc
 * product.selected_variant (Dawn fetch bằng ?option_values= → selected_variant không chắc set).
 * Dawn re-render #ProductInfo khi đổi variant → dùng listener document + MutationObserver để sống sót.
 */
(function () {
  var PREFIX = 'Thêm vào giỏ';
  var CHOOSE = 'Chọn size';
  var SOLD_OUT = 'Đã bán hết';

  function sizePicker() {
    // CHỈ picker size thật (data-size-gate) mới gate CTA — chip "Phân loại" dùng chung
    // giao diện .honest-size-picker nhưng chọn sẵn, không được tính là size.
    return (
      document.querySelector('.honest-pdp .honest-size-picker[data-size-gate]') ||
      document.querySelector('.honest-size-picker[data-size-gate]')
    );
  }

  // { mode: 'single' | 'unchosen' | 'chosen', size, available }
  function sizeState() {
    var sp = sizePicker();
    if (!sp) return { mode: 'single' };
    var chk = sp.querySelector('input[type="radio"]:checked');
    if (!chk) return { mode: 'unchosen' };
    return { mode: 'chosen', size: (chk.value || '').trim(), available: !chk.classList.contains('disabled') };
  }

  function setDisabled(btn, want) {
    if (!btn) return;
    var is = btn.hasAttribute('disabled');
    if (want && !is) btn.setAttribute('disabled', '');
    else if (!want && is) btn.removeAttribute('disabled');
  }

  function setLabel(btn, label) {
    if (!btn || label == null) return;
    var span = btn.querySelector('span') || btn;
    if (span.textContent !== label) span.textContent = label; // guard tránh vòng lặp observer
  }

  function apply() {
    var main = document.querySelector('.honest-pdp .product-form__submit');
    var buyNows = document.querySelectorAll('.honest-pdp [data-buy-now]'); // có thể 2 nút: form chính (ẩn) + form combo
    var sticky = document.querySelector('[data-pdp-sticky-atc] .pdp-sticky-atc__btn');
    var combo = document.querySelector('.honest-pdp .combo-plan__submit');
    var st = sizeState();

    function setBuyNows(disabled) {
      buyNows.forEach(function (b) { setDisabled(b, disabled); });
    }

    // SP có combo plan-cards → ATC này là CTA "mua 1 lần" kiểu Coterie: prefix "Mua lẻ" + giá (Liquid gắn data-price).
    var comboCtx = main && main.dataset && main.dataset.comboContext;
    var prefix = comboCtx ? 'Mua lẻ' : PREFIX;
    var priceSuffix = comboCtx && main.dataset.price ? ' · ' + main.dataset.price : '';

    if (st.mode === 'unchosen') {
      setDisabled(main, true); setLabel(main, CHOOSE);
      setBuyNows(true);
      setDisabled(sticky, true); setLabel(sticky, CHOOSE);
      setDisabled(combo, true); setLabel(combo, CHOOSE);
      return;
    }
    if (st.mode === 'chosen' && st.available === false) {
      setDisabled(main, true); setLabel(main, SOLD_OUT);
      setBuyNows(true);
      setDisabled(sticky, true); setLabel(sticky, SOLD_OUT);
      setDisabled(combo, true); setLabel(combo, SOLD_OUT);
      return;
    }
    if (st.mode === 'chosen') {
      setDisabled(main, false);
      setLabel(main, prefix + ' — Size ' + st.size + priceSuffix);
      setBuyNows(false);
      setDisabled(sticky, false); setLabel(sticky, PREFIX + ' hàng');
      setDisabled(combo, false);
      if (combo && combo.dataset.readyLabel) setLabel(combo, combo.dataset.readyLabel);
      return;
    }
    // mode 'single' (không có lưới size gate): Liquid + Dawn là nguồn sự thật cho disabled —
    // KHÔNG ép mở nút (SP hết hàng render disabled phải giữ nguyên). Chỉ vá nhãn bị
    // toggleSubmitButton của Dawn đè về "Thêm vào giỏ" sau khi đổi variant (Phân loại…).
    if (comboCtx && main && !main.hasAttribute('disabled')) setLabel(main, prefix + priceSuffix);
    if (combo && !combo.hasAttribute('disabled') && combo.dataset.readyLabel) {
      setLabel(combo, combo.dataset.readyLabel);
    }
  }

  // 1) Đổi size (event delegation) — cập nhật NGAY, mượt như Coterie; observer xác nhận lại sau re-render.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.honest-size-picker[data-size-gate] input[type="radio"]')) {
      apply();
    }
  });

  // 2) Dawn re-render buy-box → áp lại trạng thái (nút bị thay bằng HTML Liquid gốc).
  function observe() {
    var target = document.querySelector('#MainContent') || document.body;
    new MutationObserver(function () { apply(); }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') { apply(); observe(); }
  else document.addEventListener('DOMContentLoaded', function () { apply(); observe(); });
})();
